<template>
  <footer>
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>Space Coast STEM</h3>
          <p>Empowering students in Brevard County through technology and education.</p>
        </div>
        <div class="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><router-link to="/about">About Us</router-link></li>
            <li><router-link to="/get-involved">Get Involved</router-link></li>
            <li><router-link to="/contact">Contact</router-link></li>
          </ul>
        </div>
        <div class="footer-section">
          <h4>Contact</h4>
          <p>Email: info@spacecoaststem.org</p>
          <p>Brevard County, Florida</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2025 Space Coast STEM Inc. All rights reserved</p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
// Footer component - no reactive logic needed
</script>

<style scoped>
/* Footer */
footer {
  background: var(--dark-bg, #1f3447);
  color: var(--white, #ffffff);
  padding: 3rem 2rem 1rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-section h3,
.footer-section h4 {
  margin-bottom: 1rem;
  color: var(--white, #ffffff);
  font-family: 'Poppins', sans-serif;
}

.footer-section p {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
}

.footer-section ul {
  list-style: none;
  padding: 0;
}

.footer-section ul li {
  margin-bottom: 0.5rem;
}

.footer-section ul li a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: color 0.3s;
}

.footer-section ul li a:hover {
  color: var(--secondary-color, #3ba3d1);
}

.footer-bottom {
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
}
</style>
